export default {
  namespaced: true,
  state: {
    paymentMethod: "normal",
    accountPaymentInfo: {
      paymentModeCode: "directdebit",
      amount: 0,
      code: "directdebit",
    },
    accountPassword: {
      secret: "",
      validated: false,
    },
  },
  mutations: {
    reset(state) {
      state.paymentMethod = "normal";
      state.accountPaymentInfo = {
        paymentModeCode: "directdebit",
          amount: 0,
          code: "directdebit",
      };
      state.accountPassword = {
        secret: "",
        validated: false,
      };
    },
    accountAmount(state, value = 0) {
      state.accountPaymentInfo.amount = value;
    },
    updatePassword(state, value = {}) {
      state.accountPassword.secret = value.secret;
      state.accountPassword.validated = value.validated;
    },
  }
  ,
  getters: {
    accountPaymentInfo(state) {
      return state.accountPaymentInfo;
    },
    password(state) {
      return state.accountPassword;
    },
  },

}
